import { PreviewTable } from '../../common/PreviewTable';
import { EmptyState } from '../../common/EmptyState';
import type { PreviewTableColumn } from '../../common/PreviewTable';
import type { Product, ProductStockItem } from '../types';
import { useTranslation } from '@hooks/useTranslation';
import { formatDateRange } from '~/react/utils/formatters';

interface StockSectionProps {
  product: Product;
}

export function StockSection({ product }: StockSectionProps) {
  const { t } = useTranslation();

  const columns: PreviewTableColumn<ProductStockItem>[] = [
    {
      key: 'stock_count',
      header: t('index.stock.columns.stock_count'),
      render: (item) => (
        <span className="font-inter text-sm text-off-black">{item.quantity}</span>
      ),
      width: '1fr',
    },
    {
      key: 'date_range',
      header: t('index.stock.columns.date_range'),
      render: (item) => (
        <span className="font-inter text-sm text-off-black">
          {formatDateRange(item.start_date, item.end_date)}
        </span>
      ),
      width: '2fr',
    },
  ];

  return (
    <div className="space-y-4">
      <h3 className="font-kapra-expanded text-2xl font-black uppercase leading-tight text-off-black">
        {t('index.stock.title')}
      </h3>

      {product.stock_items.length > 0 ? (
        <PreviewTable
          columns={columns}
          data={product.stock_items}
          getRowKey={(item) => item.id}
        />
      ) : (
        <EmptyState label={t('index.stock.no_item')} />
      )}
    </div>
  );
}
